(function () {
    function lhm_loadKbeScript() {
        if (window.__KBE) {
            return;
        }

        !function (t, e, n, s) {
            t['kbe-widgets'] = s;
            t[s] = t[s] || new Proxy({ q: [] }, {
                get: (e, n) => (n in e ? e[n] : function (e) {
                    t[s].q.push([n, e]);
                }),
            });

            const o = e.createElement(n);
            const r = e.getElementsByTagName(n)[0];

            o.id = s;
            o.src = 'https://widget-bf.seekda.com/loader.js';
            o.async = 1;
            r.parentNode.insertBefore(o, r);
        }(window, document, 'script', '__KBE');
    }

    function lhm_initBuchenWidget(roomCode, language, widgetId) {
        lhm_loadKbeScript();

        window.__KBE.settings({
            id: widgetId,
            propertyCode: 'S000242',
        });

        window.__KBE.rates({
            layout: 2,
            loadingBlocks: 5,
            showDescription: false,
            showSpecs: true,
            roomCodes: roomCode,
            categories: '',
            id: widgetId,
            language: language,
        });
    }

    window.lhm_initBuchenWidget = lhm_initBuchenWidget;
})();
